import { EventEmitter } from "@angular/core";
export class BeforeNextStepEventHandler {
  constructor(private canContinue: EventEmitter<boolean>) {}

  next() {
    this.canContinue.emit(true);
  }

  cancel() {
    this.canContinue.emit(false);
  }
}
